import styled from "styled-components";

export const Switcher = styled.div`
  position: relative;
  margin-right: 15px;

  &.auth {
    width: 40px;
    button {
      width: 100%;
      color: #333842;
    }
    @media (min-width: 568px) {
      width: 55px;
    }
  }
`;

export const NavBtn = styled.button`
  font-size: 12px;
  letter-spacing: 0.25px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 10px 4px;
  font-weight: 700;
  color: #b6bbc8;
  &:hover {
    color: #e6000f;
  }

  &.active {
    color: #333842;
  }
`;

export const Splitter = styled.span`
  color: #333842;
  font-size: 16px;
`;
